module.exports = __webpack_public_path__ + "static/node_js_ruby_on_rails_elixir_phoenix-672fa9aae80aee9af1fdf45aaf71fb39.png";